import { Permissions } from "permissions";
import { RouteDescription } from "types";
import { LOPReport } from "./LOPReport";

export const downloadLOPRoutes: RouteDescription[] = [
  {
    menuItem: {
      id: "download-lop",
      label: <LOPReport /> as any as string,
    },
    requiredOneOfPermissions: [
      Permissions.Admin,
      Permissions.SuperAdmin,
      Permissions.Compliance,
    ],
  } as RouteDescription,
];

